import React from 'react'

export default function DisclaimerBox() {
  return (
    <div className="DisclaimerBox">
      All products must be installed by a licensed electrician in accordance with wiring rules AS/NZS 3000
    </div>
  )
}
